<template>
  <div>
    <div class="success" v-if="authenticated">
      <p>
        <strong>Frechdax Teammitglied</strong><br />
        Du bist als Frechdax eingeloggt. Die Ticketbeschränkungen sind für dich
        aufgehoben.
      </p>
    </div>
    <article>
      <header>
        <h2>{{ $t("ticketShop.title") }}</h2>
      </header>
      <main>
        <p>
          <i18n
            :path="
              ticketSaleActive
                ? 'ticketShop.tldrSaleActive'
                : 'ticketShop.tldrSalePending'
            "
            tag="strong"
          >
            <template v-slot:nextPartyDay>{{ currentPartyDate.day }}</template>
            <template v-slot:nextPartyMonthname>{{
              $t(`monthNames[${currentPartyDate.month - 1}]`)
            }}</template>
            <template v-slot:nextPartyMonth>{{
              currentPartyDate.month
            }}</template>
            <template v-slot:nextPartyYear>{{
              currentPartyDate.year
            }}</template>
          </i18n>
        </p>
        <p>
          {{ $t("ticketShop.ticketNotesIntroduction") }}
        </p>
        <ul>
          <li>
            {{ $t("ticketShop.ticketNotes.price") }}
          </li>
          <li>
            {{ $t("ticketShop.ticketNotes.transferable") }}
          </li>
          <li>
            {{ $t("ticketShop.ticketNotes.storno") }}
          </li>
          <li>
            {{ $t("ticketShop.ticketNotes.validity") }}
          </li>
        </ul>
      </main>
    </article>
    <div
      class="mobile-grid"
      :style="{
        gridTemplateColumns: `repeat(${TICKETS.tilesPerRow}, 1fr)`,
        gap: '20px',
      }"
    >
      <TicketPackage
        v-for="ticket in TICKETS.packages"
        :accentClass="ticket.accentClass"
        :title="ticket.title"
        :description="ticket.description"
        :price="ticket.price"
        :partyIds="ticket.partyIds"
        :ticketShopId="ticket.ticketShopId"
        :disabled="ticket.disabled"
        :fullSize="ticket.fullSize"
        :authenticated="authenticated"
        :soldOut="ticket.soldOut"
        :availableSoon="!ticketSaleActive && !ticket.ignoreTicketSaleStart"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import PartyCircles from "@/components/party-circles";
import TicketPackage from "@/components/TicketPackage";
import TICKETS from "@/data/tickets.yml";

let now = new Date();

const TICKET_SALE_START = JSON.parse(process.env.VUE_APP_TICKET_SALE_START);

const ticketSaleStartDate = new Date(
  Date.UTC(
    TICKET_SALE_START.year,
    TICKET_SALE_START.month - 1,
    TICKET_SALE_START.day,
    TICKET_SALE_START.hour + TICKET_SALE_START.utcOffset,
    0
  )
);

const ticketSaleStartDateKnown =
  process.env.VUE_APP_TICKET_SALE_START != process.env.VUE_APP_NEXT_PARTY_DATE;

export default {
  components: {
    PartyCircles,
    TicketPackage,
  },
  data() {
    return {
      authenticated: false,
      ticketSaleStart: ticketSaleStartDateKnown ? ticketSaleStartDate : now,
      nextPartyDate: JSON.parse(process.env.VUE_APP_NEXT_PARTY_DATE),
      currentPartyDate: JSON.parse(process.env.VUE_APP_PARTY_DATE),
      now: now,
      TICKETS,
    };
  },
  computed: {
    ticketSaleActive() {
      return this.ticketSaleStart - this.now < 0;
    },
  },
  methods: {
    authenticate() {
      const credentials = JSON.parse(localStorage.getItem("API_CREDENTIALS"));
      this.authenticated = credentials && true;
    },
  },
  created() {
    window.setInterval(() => {
      this.now = new Date();
    }, 300);
  },
  mounted() {
    this.authenticate();
  },
};
</script>

<style scoped lang="scss">
div.mobile-grid {
  display: grid;
  margin: 2em 0;

  @media screen and (max-width: 720px) {
    display: block;
  }
}

article main {
  display: flex;
  flex-direction: column;
}

.included-tickets {
  flex-grow: 1;
  margin-bottom: 20px;
}
</style>

<i18n>
  {
    "de": {
      "ticketShop": {
        "title": "Ticket-Vorverkauf",
        "tldrSaleActive": "Die Tickets für die frɘchdax ABDL Party im {nextPartyMonthname} {nextPartyYear} sind ab sofort verfügbar!",
        "tldrSalePending": "Die Tickets für die frɘchdax ABDL Party im {nextPartyMonthname} {nextPartyYear} sind in Kürze verfügbar.",
        "ticketNotesIntroduction": "Bitte beachtet beim Ticketkauf folgende Hinweise:",
        "ticketNotes": {
          "guestlist": "Entgegen der Regelungen für 2020 ist zum Einlass zur Party keine Vorabregistrierung beim Münchner Löwen Club notwendig.",
          "price": "Die Tickets werden durch einen externen Ticketshop vertrieben, daher können Systemgebühren anfallen.",
          "transferable": "Alle Tickets sind vor ihrer Einlösung übertragbar, auch wenn der Name des Ticketkäufers aufgedruckt sein sollte.",
          "storno": "Die Stornierung der Tickets ist ausgeschlossen.",
          "validity": "Die Gültigkeit des Tickets verfällt mit dem Eintritt. Ticketpakete können nur einmalig eingelöst werden."
        }
      }
    },
    "en": {
      "ticketShop": {
        "title": "Ticket Sale Open",
        "tldrSaleActive": "Tickets for the next frɘchdax ABDL party in {nextPartyMonthname} {nextPartyYear} are available now!",
        "tldrSalePending": "Tickets for the next frɘchdax ABDL party in {nextPartyMonthname} {nextPartyYear} are available soon.",
        "ticketNotesIntroduction": "Please note:",
        "ticketNotes": {
          "guestlist": "Unlike the 2020's rule, there is no need to register yourself at the Münchner Löwen Club beforehand.",
          "price": "Our tickets are distributed by an external ticket shop, which may add system fees on top of the ticket price.",
          "transferable": "Every ticket is transferable until it gets redeemed, even when the buyer's name may be printed on it.",
          "storno": "Tickets are not refundable.",
          "validity": "Tickets will be valid for entering the party once. Package tickets can be redeemed only once."
        }
      }
    }
  }
</i18n>
<i18n src="@/locales/global.json" />
